<template>
  <section id="lists">
    <div class="demo">
      <div class="d-flex flex-column flex-md-row">
        <div class="list-group list-group-flush nav" id="myList" role="tablist">
          <a class="list-group-item list-group-item-action active" data-toggle="tab" href="#list1" role="tab">List one</a>
          <a class="list-group-item list-group-item-action" data-toggle="tab" href="#list2" role="tab">List two</a>
          <a class="list-group-item list-group-item-action" data-toggle="tab" href="#list3" role="tab">List three</a>
          <a class="list-group-item list-group-item-action" data-toggle="tab" href="#list4" role="tab">List four</a>
          <a class="list-group-item list-group-item-action disabled" data-toggle="tab" href="#list5" role="tab">List five</a>
        </div>
        <div class="tab-content">
          <div class="tab-pane show active" id="list1" role="tabpanel">
            <h5>Heading 1 - 1</h5>
            <p>Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
            </p>
            <h5>Heading 1 - 2</h5>
            <p>Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
          </div>
          <div class="tab-pane" id="list2" role="tabpanel">
            <h5>Heading 2 - 1</h5>
            <p>Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
            </p>
            <h5>Heading 2 - 2</h5>
            <p>Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
          </div>
          <div class="tab-pane" id="list3" role="tabpanel">
            <h5>Heading 3 - 1</h5>
            <p>Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
            </p>
            <h5>Heading 3 - 2</h5>
            <p>Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
          </div>
          <div class="tab-pane" id="list4" role="tabpanel">
            <h5>Heading 4 - 1</h5>
            <p>Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
            </p>
            <h5>Heading 4 - 2</h5>
            <p>Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
          </div>
        </div>
      </div>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/components/lists.md";
export default {
  name: "lists",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.lists.name);
    this.$emit("update-tagline", this.$root.yamlData.components.lists.description);
  },
  mounted: function () {
    const tabs = document.querySelectorAll('[data-toggle="tab"]')
    tabs.forEach(tab => {
      new BSN.Tab(tab)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
